// SEO metadata for each service page
export const serviceSEO = {
  "residential-painting": {
    title: "Interior & Exterior Painting Dallas TX | House Painters | Gray Contracting",
    primaryKeyword: "painting contractor Dallas",
    description: "Professional interior & exterior painting services in Dallas, TX. Gray Contracting offers house painting, cabinet refinishing, deck staining & more. 55+ years experience. Licensed & insured. Free estimates. Call 214-908-7644.",
    h1: "Residential Painting Services in Dallas",
    keywords: "interior painting Dallas, exterior painting Dallas, house painters Dallas TX, cabinet painting Dallas, residential painting Dallas, painting company Dallas Fort Worth"
  },
  "remodeling-renovations": {
    title: "Home Remodeling Dallas TX | Kitchen & Bathroom Renovation | Gray Contracting",
    primaryKeyword: "home remodeling Dallas",
    description: "Expert home remodeling & renovation services in Dallas, TX. Kitchen remodels, bathroom renovations, room additions & more. 55+ years of trusted craftsmanship. Free estimates. Call 214-908-7644.",
    h1: "Remodeling & Renovations in Dallas",
    keywords: "home remodeling Dallas, kitchen remodel Dallas TX, bathroom renovation Dallas, home renovation contractor Dallas, remodeling company Dallas Fort Worth"
  },
  "drywall-repair": {
    title: "Drywall Repair & Installation Dallas TX | Texture Matching | Gray Contracting",
    primaryKeyword: "drywall repair Dallas",
    description: "Professional drywall repair & installation in Dallas, TX. Hole patching, water damage repair, texture matching, popcorn ceiling removal. 55+ years experience. Free estimates. Call 214-908-7644.",
    h1: "Drywall Repair & Installation in Dallas",
    keywords: "drywall repair Dallas, drywall installation Dallas TX, drywall contractor Dallas, texture matching Dallas, ceiling repair Dallas Fort Worth"
  },
  "carpentry": {
    title: "Carpentry Services Dallas TX | Trim & Custom Woodwork | Gray Contracting",
    primaryKeyword: "carpentry services Dallas",
    description: "Expert carpentry services in Dallas, TX. Crown molding, trim work, custom built-ins, door installation & more. 55+ years of skilled craftsmanship. Licensed & insured. Free estimates. Call 214-908-7644.",
    h1: "Carpentry Services in Dallas",
    keywords: "carpentry Dallas TX, trim carpenter Dallas, crown molding installation Dallas, custom woodwork Dallas, carpenter Dallas Fort Worth"
  },
  "tile-installation": {
    title: "Tile Installation Dallas TX | Kitchen & Bathroom Tile | Gray Contracting",
    primaryKeyword: "tile installation Dallas",
    description: "Professional tile installation in Dallas, TX. Kitchen backsplash, bathroom tile, floor tile, shower surrounds & more. 55+ years experience. Free estimates. Call 214-908-7644.",
    h1: "Tile Installation in Dallas",
    keywords: "tile installation Dallas, tile contractor Dallas TX, kitchen backsplash Dallas, bathroom tile Dallas, floor tile installation Dallas Fort Worth"
  },
  "exterior-siding": {
    title: "Siding Installation & Repair Dallas TX | Vinyl & Fiber Cement | Gray Contracting",
    primaryKeyword: "siding contractor Dallas",
    description: "Expert siding installation & repair in Dallas, TX. Vinyl siding, fiber cement, wood siding repair, storm damage repair. 55+ years experience. Free estimates. Call 214-908-7644.",
    h1: "Exterior Siding in Dallas",
    keywords: "siding contractor Dallas, siding installation Dallas TX, vinyl siding Dallas, fiber cement siding Dallas, siding repair Dallas Fort Worth"
  },
  "deck-construction": {
    title: "Deck Builder Dallas TX | Custom Deck Construction | Gray Contracting",
    primaryKeyword: "deck builder Dallas",
    description: "Custom deck construction & repair in Dallas, TX. Wood decks, composite decking, pergolas, deck staining & sealing. 55+ years experience. Licensed & insured. Free estimates. Call 214-908-7644.",
    h1: "Deck Construction in Dallas",
    keywords: "deck builder Dallas, deck construction Dallas TX, composite deck Dallas, deck repair Dallas, deck contractor Dallas Fort Worth"
  },
  "mold-remediation": {
    title: "Mold Remediation Dallas-Fort Worth, TX | Gray Contracting",
    primaryKeyword: "mold remediation Dallas",
    description: "Professional mold remediation across Dallas-Fort Worth. Get help with containment, removal, moisture-related damage and reconstruction. Call Gray Contracting at 214-908-7644.",
    h1: "Mold Remediation in Dallas-Fort Worth",
    keywords: "mold remediation Dallas, mold removal Dallas TX, mold testing Dallas, black mold removal Dallas, mold remediation Fort Worth, attic mold remediation Dallas, mold damage repair Dallas"
  },
  "parking-lot-striping": {
    title: "Parking Lot Striping Dallas TX | ADA Compliant Line Painting | Gray Contracting",
    primaryKeyword: "parking lot striping Dallas",
    description: "Professional parking lot striping, seal coating & asphalt repair in Dallas, TX. ADA-compliant markings, fire lane painting, commercial & multi-family property layouts. 55+ years experience. Free estimates. Call 214-908-7644.",
    h1: "Parking Lot Striping & Asphalt Services in Dallas",
    keywords: "parking lot striping Dallas, parking lot painting Dallas TX, ADA compliant striping Dallas, fire lane painting Dallas, seal coating Dallas, asphalt repair Dallas Fort Worth"
  },
  "brick-masonry": {
    title: "Brick & Masonry Services Dallas TX | Stonework & Repairs | Gray Contracting",
    primaryKeyword: "masonry contractor Dallas",
    description: "Expert brick & masonry services in Dallas, TX. Brick ties, tuckpointing, fireplace repair, stonework, mailboxes, stucco & stone landscaping. 55+ years experience. Licensed & insured. Free estimates. Call 214-908-7644.",
    h1: "Brick & Masonry Services in Dallas",
    keywords: "masonry contractor Dallas, brick repair Dallas TX, tuckpointing Dallas, stonework Dallas, stucco repair Dallas, fireplace repair Dallas Fort Worth"
  },
  "roof-repairs": {
    title: "Roof Repair Dallas TX | Leak Repair & Waterproofing | Gray Contracting",
    primaryKeyword: "roof repair Dallas",
    description: "Professional roof repair & exterior leak solutions in Dallas, TX. Shingle repair, waterproof sealing, leak detection & emergency repairs. 55+ years experience. Licensed & insured. Free estimates. Call 214-908-7644.",
    h1: "Roof & Exterior Leak Repairs in Dallas",
    keywords: "roof repair Dallas, roof leak repair Dallas TX, exterior waterproofing Dallas, shingle repair Dallas, roofing contractor Dallas Fort Worth"
  }
};

// Page-specific SEO
export const pageSEO = {
  home: {
    title: "Dallas Painting Contractor | Interior & Exterior House Painters | Gray Contracting",
    description: "Top-rated Dallas painting contractor with 55+ years experience. Interior & exterior house painters, remodeling, drywall & more. Free estimates. Call 214-908-7644."
  },
  about: {
    title: "About Gray Contracting | Dallas Painting & Remodeling Since 1969",
    description: "Learn about Gray Contracting, a family-owned painting & remodeling contractor serving Dallas-Fort Worth since 1969. 55+ years of trusted craftsmanship. Licensed, insured & certified."
  },
  services: {
    title: "Home Improvement Services Dallas TX | Painting, Remodeling & More | Gray Contracting",
    description: "Full-service residential contractor in Dallas, TX. Painting, remodeling, drywall, carpentry, tile, siding, decks & mold remediation. 55+ years experience. Free estimates. Call 214-908-7644."
  },
  contact: {
    title: "Contact Gray Contracting | Free Estimates Dallas TX | 214-908-7644",
    description: "Contact Gray Contracting for a free estimate on painting, remodeling & home improvement in Dallas-Fort Worth. Call 214-908-7644 or fill out our form. Serving Dallas, Plano, Frisco & more."
  },
  gallery: {
    title: "Project Gallery | Painting & Remodeling Work | Gray Contracting Dallas",
    description: "Browse our portfolio of completed painting, remodeling & home improvement projects in Dallas-Fort Worth. See the quality craftsmanship that defines Gray Contracting."
  }
};
